// extracted by mini-css-extract-plugin
export var iframe = "events-module--iframe--pTopg";